
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.954 10l-.025-2.5a5.551 5.551 0 00-11.1.11L6.851 10A2.009 2.009 0 005 12v2.614A7.4 7.4 0 0012.382 22a7.4 7.4 0 007.382-7.382V12a2.01 2.01 0 00-1.81-2zm-4.786 5.549v2.915a.324.324 0 01-.322.322h-1.029a.324.324 0 01-.322-.322v-2.915a1.723 1.723 0 111.673 0zM8.615 9.994l-.024-2.406a3.787 3.787 0 017.573-.075l.025 2.481z","fill":"#222"}})])
          )
        }
      }
    